module.exports = new __parcel__URL__("salesforce.14a9fddf.svg").toString();